import styled from 'styled-components'

export const ModalContent = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
  width: '47rem',
}))

export const CommentSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
}))

export const ExistingComment = styled.div(({ theme }) => ({
  alignItems: 'flex-start',
  backgroundColor: theme.colors.gray100,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
  padding: theme.space['16'],
}))

export const EditButtonWrapper = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
})
